const ResumeData = [
  {
    id: 1,
    category: "education",
    year: "2020-2024",
    title: "Bachelor's of technology",
    desc: "Pursing B.tech in Computer Science and Engineering from Bikaner Technical University ",
  },
  {
    id: 2,
    category: "education",
    year: "2020",
    title: "12th",
    desc: "Passed my 12th from Rajasthan Board of secondary Education",
  },
  {
    id: 3,
    category: "education",
    year: "2018",
    title: "10th",
    desc: "Passed 10th exam from Rajasthan Board of secondary Education",
  },
  {
    id: 4,
    category: "experience",
    year: "April 2024 - November 2024",
    title: "Associate Software Intern",
    desc: "Associate Software Intern on Future Solvers Pvt. Ltd.,Remote ",
  },
  {
    id: 4,
    category: "experience",
    year: "May 2023 - August 2023",
    title: "Associate Software Intern",
    desc: "Associate Software Intern on Shipway Technology Pvt. Ltd., Gurugram ",
  },
  {
    id: 5,
    category: "experience",
    year: "December 2022 -February 2023 ",
    title: "Graphic Designer",
    desc: "I have Completed my 3 month training as a Graphic Designer on Aashman Foundation",
  },
];

export default ResumeData;
